<template>
  <div>
    <div class="app-content content">
      <div class="content-wrapper">
        <div class="content-wrapper-before"></div>
        <div class="content-header row"></div>
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted: function () {
    $('body').attr('class', 'vertical-layout vertical-menu 1-column  bg-full-screen-image menu-expanded blank-page blank-page').attr('data-col', '1-column')
  }
}
</script>
